// hooks
import { useGoBack } from 'hooks/useGoBack';
import { useNavigate } from 'react-router-dom';
import { DYNAMIC_ROUTES } from 'router';

// store
import {
  useBookmarkArticleMutation,
  useGetAllArticleBookmarkQuery,
} from 'store/api/cms';
import { Article } from '@karehero/models';

// components
import ArticleBookmarksPage from '@karehero/llama/components/pages/ArticleBookmarks/ArticleBookmarks';

/**
 * ArticleBookmarks shows the content library.
 */
export const ArticleBookmarks = () => {
  // hooks
  const goBack = useGoBack();
  const navigate = useNavigate();
  const { data: articleBookmarks } = useGetAllArticleBookmarkQuery();
  const [bookmarkArticle] = useBookmarkArticleMutation();

  return (
    <ArticleBookmarksPage
      articles={articleBookmarks}
      onBookmark={(article: Partial<Article>) =>
        bookmarkArticle(article._id || '')
      }
      onArticleClick={(article) =>
        navigate(DYNAMIC_ROUTES.LIBRARY_ARTICLE(article?.slug?.current))
      }
      isLoading={false}
      onBack={goBack}
    />
  );
};

export default ArticleBookmarks;
